import { render, staticRenderFns } from "./switchLocale.vue?vue&type=template&id=e2b935d2"
import script from "./switchLocale.vue?vue&type=script&lang=js"
export * from "./switchLocale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports